import type { FC } from 'react'
import { Flex } from 'antd'
import { useEffect } from 'react'

import { Button, Drawer, Heading } from '@/components'
import { useBecomeShareholderStore } from '../store'
import thumbsUpPng from './img/thumbs-up.png'


interface T_BecomeShareholderStep3DrawerProps {
  isPaymentInProcess: boolean
  payFee: () => void
}

export const BecomeShareholderStep3Drawer: FC<T_BecomeShareholderStep3DrawerProps> = ({
  isPaymentInProcess,
  payFee,
}) => {

  useEffect(() => {
    if (!isPaymentInProcess) {
      hideBecomeShareholderStep3Drawer()
    }
  }, [ isPaymentInProcess ])

  const hideBecomeShareholderStep3Drawer = useBecomeShareholderStore((s) => s.hideBecomeShareholderStep3Drawer)


  return (
    <Drawer
      isBackdropClosable
      onClose={hideBecomeShareholderStep3Drawer}
    >
      <Flex justify='center'>
        <img
          src={thumbsUpPng}
          style={{ margin: '0 auto' }}
          alt=''
        />
      </Flex>

      <Heading level={1} centered>
        Заявка принята
      </Heading>

      <p style={{ margin: '8px 0 24px', textAlign: 'center' }}>
        Ваша заявка принята. Теперь необходимо оплатить паевой взнос в размере 100 рублей.
      </p>

      <Button
        block
        $isBlack
        onClick={payFee}
        loading={isPaymentInProcess}
        disabled={isPaymentInProcess}
        $isVeryRadiused
        $extraSize='veryLarge'
      >
        {isPaymentInProcess ? 'Идёт оплата..' : 'Оплатить взнос' }
      </Button>

      <br /><br />

      <Button
        size='small'
        $isVeryRadiused
        $extraSize='veryLarge'
        block
        ghost
        onClick={hideBecomeShareholderStep3Drawer}
      >
        Оплачу позже
      </Button>
    </Drawer>
  )
}
